// The `TermsAndCondition` component renders a detailed terms and conditions page by
// mapping through sections and content. Each section includes a title and a list of
// points, where each point may contain highlighted text or links. The component
// dynamically generates content based on the provided `agContent` prop, which
// contains section titles and answers. It styles the content using Tailwind CSS, with
// special handling for highlighted text and links. The component ensures proper structure by
// rendering a horizontal line between sections.

import React from 'react';
import { Section, TermsAndConditions, Answer } from 'types/next';

interface TermsAndConditionProps {
  agContent: TermsAndConditions;
}

const TermsAndCondition = ({ agContent }: TermsAndConditionProps) => {
  return (
    <div className="Terms and Condition">
      <h2 className="mb-30 text-start text-36 font-bold">{agContent?.name}</h2>
      <div>
        {agContent?.sections?.map((tandc: Section, sectionIndex: number) => {
          return (
            <div key={sectionIndex}>
              <h3 className="pb-20 text-28 font-semibold">{tandc?.sectionTitle}</h3>
              <div>
                {tandc?.content?.map((content, contentIndex) => (
                  <div key={contentIndex}>
                    <div className="flex">
                      <span className="mr-2 mt-5 text-16 font-bold">{contentIndex + 1}.</span>{' '}
                      <div>
                        {content?.answer?.map((segment: Answer, answerIndex: number) => (
                          <p key={answerIndex} className="answer text-16 font-normal leading-7 tracking-wide">
                            {segment.highlight ? (
                              segment.link ? (
                                <a
                                  href={segment.link}
                                  className="highlighted-link cursor-pointer pe-3 ps-3 font-bold text-[#1dce8f] underline hover:text-[#1dce8f]"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  {segment.text}
                                </a>
                              ) : (
                                <span className="highlighted-text pe-1 ps-1 font-bold">{segment.text}</span>
                              )
                            ) : (
                              <span>{segment.text}</span>
                            )}
                          </p>
                        ))}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <hr className="my-20" />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TermsAndCondition;
